import { NativeSelect } from "@/components/ui/NativeSelect";
import {
  formatDinPaperLabel,
  type DinPaperSize,
  type PaperOrientation,
} from "@/lib/paperSize";
import { paperSizeSelectOptions } from "@/lib/documentPaperOverrides";

export function PaperSizeBar({
  pageNum,
  pageCount,
  detected,
  orientation,
  value,
  onChange,
}: {
  pageNum: number;
  pageCount: number;
  detected: DinPaperSize | null;
  orientation?: PaperOrientation;
  value: DinPaperSize | null;
  onChange: (size: DinPaperSize) => void;
}) {
  const selected = value ?? detected ?? "A4";
  const overridden = Boolean(value && value !== detected);
  const sheetLabel = pageCount > 1 ? `Blatt ${pageNum} / ${pageCount}` : "Blatt 1";

  return (
    <div className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-separator bg-card/80 px-2.5 py-1.5">
      <div className="min-w-0">
        <p className="text-xs font-medium text-label">
          {sheetLabel}
          <span className="ml-1.5 text-label-secondary">
            {formatDinPaperLabel(detected, orientation)}
            {overridden ? " · überschrieben" : ""}
          </span>
        </p>
      </div>
      <label className="flex items-center gap-2 text-xs text-label-secondary">
        <span className="shrink-0">Papier</span>
        <NativeSelect
          selectSize="sm"
          aria-label={`Papierformat ${sheetLabel}`}
          value={selected}
          onChange={(event) => onChange(event.target.value as DinPaperSize)}
        >
          {paperSizeSelectOptions().map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </NativeSelect>
      </label>
    </div>
  );
}
